import { Link } from "react-router-dom";
import { Linkedin, Twitter } from "lucide-react";

const navLinks = [
  { label: "Inicio", href: "/" },
  { label: "Sobre mí", href: "/sobre-mi" },
  { label: "Ideas", href: "/ideas" },
  { label: "Ponencias", href: "/ponencias" },
  { label: "Newsletter", href: "/newsletter" },
  { label: "Contacto", href: "/contacto" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="border-t border-border bg-card mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <p className="font-serif text-xl mb-3">Eduardo Delgado</p>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              CEO y cofundador de Roams. Escribo sobre empresa, IA, estrategia y transformación del trabajo.
            </p>
          </div>

          {/* Links */}
          <div>
            <p className="label-mono mb-5">Navegación</p>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Social & contact */}
          <div>
            <p className="label-mono mb-5">Contacto</p>
            <div className="flex gap-4 mb-5">
              <a
                href="https://linkedin.com/in/eduardodelgadolobejon"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="w-9 h-9 border border-border flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={15} />
              </a>
              <a
                href="https://twitter.com/eduardodelgadol"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-twitter"
                className="w-9 h-9 border border-border flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-colors"
                aria-label="Twitter / X"
              >
                <Twitter size={15} />
              </a>
            </div>
            <Link
              to="/contacto"
              data-testid="footer-contact-cta"
              className="label-mono text-primary hover:underline"
            >
              Iniciar conversacion →
            </Link>
          </div>
        </div>

        <div className="border-t border-border pt-8 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="label-mono text-muted-foreground">&copy; {year} Eduardo Delgado Lobejón</p>
          <p className="label-mono text-muted-foreground">Humanizar primero. Digitalizar después.</p>
        </div>
      </div>
    </footer>
  );
}
